/** Преобразует строку-число к числу **/
export var numberParser = function numberParser(value) {
  if (!value) {
    return undefined;
  }

  return Number(value.replace(/[^\d.,]/g, ''));
};